// extracted by mini-css-extract-plugin
module.exports = {"container":"Desktop_container__3K74n","map-action":"Desktop_map-action__gWb9M","compass":"Desktop_compass__25Bx1","word-tour":"Desktop_word-tour__1bjI3"};